import { render, staticRenderFns } from "./AdministrationRequests.vue?vue&type=template&id=7b4e46a6&"
import script from "./AdministrationRequests.vue?vue&type=script&lang=js&"
export * from "./AdministrationRequests.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationRequests.vue?vue&type=style&index=0&id=7b4e46a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports